import { useQuery } from "react-query";
import { fetchSubmissions } from "./submissions";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

export const useSubmissions = (options) => {
    const axios = useAxiosPrivate();

    return useQuery(
        ["reports/submissions", options],
        () => fetchSubmissions(axios, options),
        {
            keepPreviousData: true,
            staleTime: 1000 * 60 * 5,
            ...options,
        }
    );
};